import ObjektService from '@/services/ObjektService'

const state = {
  items: [],
  pageCount: 1,
  totalCount: 0,
  queryParams: {
    page: 1,
    limit: 50
  },
  loading: false,
  updating: false,
  needreload: true,
  everythingLoaded: true
}

const getters = {
  items: state => state.items,
  pageCount: state => state.pageCount,
  totalCount: state => state.totalCount,
  everythingLoaded: state => !!state.everythingLoaded,
  queryParams: state => state.queryParams,
  loading: state => !!state.loading,
  updating: state => !!state.updating,
  needreload: state => !!state.needreload
}

const actions = {
  load: ({commit, dispatch}, payload) => {
    return new Promise((resolve, reject) => {
      commit('load')

      ObjektService.getObjektNotater(payload.Objektid, state.queryParams)
        .then((response) => {
          let payload = {
            items: response.data,
            pageCount: response.headers['x-paging-pagecount'] ? parseInt(response.headers['x-paging-pagecount']) : 1,
            totalCount: response.headers['x-paging-count'] ? parseInt(response.headers['x-paging-count']) : 0
          }

          commit('success', payload)
          resolve(response)
        })
        .catch((error) => {
          commit('failure')
          reject(error)
        })
    })
  },
  save: ({commit, dispatch}, data) => {
    return new Promise((resolve, reject) => {
      commit('save')

      let body
      if (data.ImageFiles && data.ImageFiles.length) {
        body = new FormData()
        if (data.Notat) body.append('Notat', data.Notat)
        if (data.SendToAccounting) body.append('SendToAccounting', '1')
        data.ImageFiles.forEach(f => body.append('ImageFiles[]', f))
      } else {
        body = data
      }

      ObjektService.addObjektNotat(data.Objektid, body)
        .then((response) => {
          commit('success_save', response.data)
          resolve(response)
        })
        .catch((error) => {
          commit('failure_save')
          reject(error)
        })
    })
  },
  delete: ({commit, dispatch}, data) => {
    return new Promise((resolve, reject) => {
      commit('delete', data.id)

      ObjektService.delObjektNotat(data.Objektid, data.id)
        .then((response) => {
          commit('success_delete', data.id)
          resolve(response)
        })
        .catch((error) => {
          commit('failure_delete', data.id)
          reject(error)
        })
    })
  },
  sendToAccounting: ({commit, dispatch}, data) => {
    return new Promise((resolve, reject) => {
      commit('sendToAccounting', data.id)

      ObjektService.sendObjektNotatToAccounting(data.Objektid, data.id)
        .then((response) => {
          commit('success_send', response.data)
          resolve(response)
        })
        .catch((error) => {
          commit('failure_send', data.id)
          reject(error)
        })
    })
  },
  reinit: ({commit, dispatch}, params) => {
    commit('reinit', params.queryParams || null)
    dispatch('load', params)
  },
  reload: ({commit, dispatch}, params) => {
    commit('reload', params.queryParams || null)
    dispatch('load', params)
  },
  setNeedReload: ({commit, dispatch}) => {
    commit('setNeedReload')
  }
}

const mutations = {
  load: (state) => {
    if (!state.updating) {
      state.loading = true

      state.items = []
      state.queryParams.page = 1
      state.pageCount = 0
      state.totalCount = 0
      state.everythingLoaded = false
    }
  },
  reinit: (state) => {
    state.items = []
    state.pageCount = 1
    state.totalCount = 0
    state.queryParams = {
      page: 1
    }
    state.loading = false
    state.updating = false
    state.needreload = true
    state.everythingLoaded = false
  },
  reload: (state, payload) => {
    state.updating = true

    if (payload !== null) {
      state.queryParams = payload
    }
  },
  save: (state) => {
    state.updating = true
  },
  delete: (state, notatId) => {
    if (state.items) {
      const index = state.items.findIndex(x => x.id === notatId)

      state.items[index] = Object.assign({}, state.items[index], { deleting: true })
    }

    state.updating = true
  },
  success: (state, payload) => {
    state.loading = false
    state.updating = false

    let newItems = payload.items || []

    newItems.forEach(i => {
      state.items.push(i)
    })

    // state.items = payload.items || []
    state.pageCount = payload.pageCount
    state.totalCount = payload.totalCount

    if (state.pageCount === state.queryParams.page) {
      state.everythingLoaded = true
    }

    state.needreload = false
  },
  failure: (state) => {
    if (state.pageCount === state.queryParams.page) {
      state.everythingLoaded = true
    }

    state.loading = false
    state.updating = false

    state.items = []
    state.pageCount = 1
    state.totalCount = 0

    state.needreload = true
  },
  success_save: (state, payload) => {
    state.loading = false
    state.updating = false

    state.items.unshift(payload)
    state.totalCount += 1
  },
  failure_save: (state) => {
    state.loading = false
    state.updating = false
  },
  success_delete: (state, notatId) => {
    state.loading = false
    state.updating = false

    if (state.items) {
      let index = state.items.findIndex(x => x.id === notatId)
      state.items.splice(index, 1)
    }

    if (state.totalCount > 0) {
      state.totalCount -= 1
    } else {
      state.totalCount = 0
    }
  },
  failure_delete: (state, notatId) => {
    if (state.items) {
      const index = state.items.findIndex(x => x.id === notatId)

      if (state.items[index].hasOwnProperty('deleting')) {
        delete state.items[index].deleting
      }

      state.items[index] = Object.assign({}, state.items[index])
    }

    state.loading = false
    state.updating = false
  },
  sendToAccounting: (state, notatId) => {
    state.updating = true

    if (state.items) {
      const index = state.items.findIndex(x => x.id === notatId)

      state.items[index] = Object.assign({}, state.items[index], { sendingToAccounting: true })
    }
  },
  success_send: (state, payload) => {
    if (state.items) {
      const index = state.items.findIndex(x => x.id === payload.id)

      if (state.items[index].hasOwnProperty('sendingToAccounting')) {
        delete state.items[index].sendingToAccounting
      }

      state.items[index] = Object.assign({}, state.items[index], payload)
    }

    state.loading = false
    state.updating = false
  },
  failure_send: (state, notatId) => {
    if (state.items) {
      const index = state.items.findIndex(x => x.id === notatId)

      if (state.items[index].hasOwnProperty('sendingToAccounting')) {
        delete state.items[index].sendingToAccounting
      }

      state.items[index] = Object.assign({}, state.items[index])
    }

    state.loading = false
    state.updating = false
  },
  setNeedReload: (state) => {
    state.needreload = true
    state.queryParams.page = 1
    state.pageCount = 1
    state.totalCount = 0
    state.items = []
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/objektnotat.js